import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import { getOffsetFromParams, getLimitFromParams } from "./utils";

class SportSeasonsDataProvider extends BaseDataProvider {
  async getList(resource, params) {
    const offset = getOffsetFromParams(params);
    const limit = getLimitFromParams(params);
    const GET = gql`
          query {
            SportSeasonsSearch(
              sportCode:"${
                params.filter.sportCode ? params.filter.sportCode : ""
              }"
              seasonCode:"${
                params.filter.seasonCode ? params.filter.seasonCode : ""
              }"
              offset:${offset}
              limit:${limit}
            ) {
              offset
              limit
              total
              data {
                sportCode
                seasonCode
                isCurrent
                schedulePeriods {
                  label
                  startDate
                  endDate
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      // ok, react-admin needs an "id" field, but we only have the natural
      // key. so create an id out of the natural key. note that for other
      // operations we may need to parse it.
      for (let i = 0; i < response.data.SportSeasonsSearch.data.length; i++) {
        const s = response.data.SportSeasonsSearch.data[i];
        s.id = s.sportCode + ":" + s.seasonCode;
      }
      return response.data.SportSeasonsSearch;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getOne(resource, params) {
    // https://marmelab.com/react-admin/FAQ.html
    const [sportCode, seasonCode] = params.id.split(":");
    const GET = gql`
          query {
            SportSeasonsSearch(
              sportCode:"${sportCode}"
              seasonCode:"${seasonCode}"
            ) {
              offset
              limit
              total
              data {
                sportCode
                seasonCode
                isCurrent
                schedulePeriods {
                  label
                  startDate
                  endDate
                }
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      const items = response.data.SportSeasonsSearch.data;
      if (items.length !== 1) return null;
      const s = items[0];
      s.id = s.sportCode + ":" + s.seasonCode;
      return { data: s };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    var objectString = JSON.stringify(params.data).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const CREATE_OBJECT = gql`
          mutation {
            CreateSportSeason(${objectString}) {
              sportCode
              seasonCode
              isCurrent
              schedulePeriods {
                label
                startDate
                endDate
              }
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreateSportSeason };
  }

  async update(resource, params) {
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    if (objectInfo.schedulePeriods)
      objectInfo.schedulePeriods.forEach((p) => {
        delete p.__typename;
      });
    delete objectInfo.id;
    delete objectInfo.__typename;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdateSportSeason(${objectString}) {
              sportCode
              seasonCode
              isCurrent
              schedulePeriods {
                label
                startDate
                endDate
              }
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      const s = response.data.UpdateSportSeason;
      s.id = s.sportCode + ":" + s.seasonCode;
      return { data: s };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async delete(resource, params) {
    const [sportCode, seasonCode] = params.id.split(":");
    const DESTROY_OBJECT = gql`
    mutation {
      DeleteSportSeason(sportCode:"${sportCode}" seasonCode:"${seasonCode}")
    }`;
    const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
    if (!response) throw new Error("BAD:", JSON.stringify(response));
    return { data: params.previousData };
  }
}

export default SportSeasonsDataProvider;
